import React from "react";
import { useTranslation } from "react-i18next";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

interface FormTabsProps {
  tab: 'propertyDetails' | 'users';
  add: boolean;
  onTabChange: (e: any, value: 'propertyDetails' | 'users') => void;
}

const FormTabs: React.FC<FormTabsProps> = ({ tab, add, onTabChange }) => {
  const { t } = useTranslation()

  return (
    <div className="card-header overflow-hidden no-padding">
      <Tabs value={tab} onChange={onTabChange} textColor='primary'>
        <Tab value="propertyDetails" label={t("property.addEdit.pageTexts.form.tabs.propertyDetails")} />
        { !add && <Tab value="users" label={t("property.addEdit.pageTexts.form.tabs.users")} /> }
      </Tabs>
    </div>
  );
};

export default FormTabs;